import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const DashboardRedirect = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const accessToken = sessionStorage.getItem("accessToken");
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const headers = accessToken
    ? {
      Authorization: `${accessToken}`,
      "Content-Type": "application/json",
    }
    : { "Content-Type": "application/json" };

  useEffect(() => {
    const fetchDashboardPages = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/user/${userDetails?.id}/getAllDashboardPages`, { headers }
        );

        const pages = response.data?.data;

        if (Array.isArray(pages) && pages.length > 0) {
          const defaultPage = pages.find(page => page.isDefault === true);
          const redirectPageId = defaultPage?.pageId || pages[0]?.pageId; // Fallback if no default
          navigate(`/dashboard/${redirectPageId}`, { replace: true });
        } else {
        }
      } catch (error) {
        console.error("Failed to fetch dashboard pages:", error);
      }
    };

    fetchDashboardPages();
  }, [baseUrl, navigate, userDetails?.id]);

  return null;
};

export default DashboardRedirect;

